import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { Autorisationer } from '@store/models';

@Component({
    selector: 'app-autorisationer-ui',
    templateUrl: './autorisationer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutorisationerComponent {

    @Input() autorisationer: Autorisationer[];
    @Output() dismiss = new EventEmitter();
    @Output() openClient = new EventEmitter<Autorisationer>();

    onOpenClient(autorisation: Autorisationer) {
        this.openClient.emit(autorisation);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
